<template>
  <div>
    <v-layout row wrap>
      <v-flex d-flex md12>
        <Toolbar>
          <div :style="{ display: 'inline-block', width: '25%' }">
            <span class="mr-4 body-2">String Inverter </span>
            <span class="Subtitle 2">
              [ {{ selectedBlockId ? selectedBlockId.text : "" }} ]
            </span>
            <span class="Subtitle 2">
              {{ selectedInverterListName }}
            </span>
          </div>
          <div
            :style="{
              display: 'inline-block',
              width: '50%',
              textAlign: 'center',
            }"
          >
            <Toggle
              :modelValue="parameterType"
              @toggleValueChange="selectParameterType"
            >
              <v-btn flat value="current">{{ $t("Current") }}</v-btn>
              <v-btn v-show="isStringRatedPowerPresent" flat value="string_dc_power">{{ $t("Power") }}</v-btn>
              <v-btn flat value="string_dc_energy_today">{{ $t("Energy") }}</v-btn>
            </Toggle>
            <Toggle
              :modelValue="scbLiveAvg"
              @toggleValueChange="toggleLiveAvgHandler"
              class="ml-2"
              v-if="isDateToday && parameterType !== 'string_dc_energy_today'"
            >
              <v-btn v-if="isItToday" flat value="live">{{ $t("Live") }}</v-btn>
              <v-btn flat value="avg">{{ $t("Average") }}</v-btn>
            </Toggle>
          </div>
          <div
            :style="{
              display: 'inline-block',
              width: '25%',
              textAlign: 'right',
            }"
          >
            <div class="body-1">
              {{ show_date }}
            </div>
          </div>
        </Toolbar>
      </v-flex>
      <v-flex ml-4 d-flex md7>
        <MapLegend
          v-for="leg in legend"
          :key="leg.name"
          :text="$t(leg.name)"
          :shape="leg.attr"
        />
      </v-flex>
    </v-layout>
    <Card>
      <Card class="pa-1 tablediv">
        <v-layout
          row
          wrap
          v-for="item in sortedData"
          :key="item[0].id"
          class="card-separation"
        >
          <v-flex md4 :class="`--${simpleString(item[0].id)} scbBox`">
            <div class="checkbox">
              <v-checkbox
                v-model="scbCheckbox[`${item[0].id}`]"
                :label="item[0].name"
                @change="selectScbHandler(item[0].id)"
              >
              </v-checkbox>
              <div class="tooltip" v-if="item[0].ref_id">
                ( {{ $t("Ch Ref Id") }}: {{ item[0].ref_id }} )
                <span class="tooltiptext">{{
                  $t("Channel Ref. Id for Underperforming String")
                }}</span>
              </div>
            </div>
            <v-layout row wrap pa-1 ma-1>
              <template v-for="card in cardData">
                <v-card
                  v-if="
                    !card.optional ||
                    (item[0][card.value] && item[0][card.value] >= 0) ||
                    (card.optional && item[0][card.value] != null)
                  "
                  :key="card.value"
                  :class="[
                    'ma-1 pa-0 card-uniform',
                    {
                      scbCardParam:
                        scbCardSelection[`${item[0].id}-${card.value}`],
                    },
                  ]"
                  @click="selectScbParameter(item[0].id, card.value)"
                >
                  <v-card-title
                    class="d-flex align-center justify-space-between"
                  >
                    <v-flex>
                      {{ card.name }}:
                      <span
                        :class="
                          card.method(item[0][card.value]) == null ||
                          card.method(item[0][card.value]) == 'No Data'
                            ? 'error--text'
                            : 'number--text'
                        "
                      >
                        {{ card.method(item[0][card.value]) }}
                      </span>
                    </v-flex>
                  </v-card-title>
                </v-card>
              </template>
              <v-spacer />
            </v-layout>
          </v-flex>

          <!-- CHANNELS HERE -->
          <v-flex md8 class="scb-channel-data">
            <v-checkbox
              class="scb_checkbox"
              :label="$t('Select All Channels')"
              v-model="channelCheckbox[item[0].id]"
              @change="selectChannelHandler(item[0])"
              :disabled="isChannelSelectDisabled(item[0].id)"
            >
            </v-checkbox>
            <CardCheckBox
              :data="item[0].channel"
              :id="item[0].id"
              :selectAll="channelCheckbox[item[0].id]"
              :clearAll="clearAllChecked"
              :disable="isChannelSelectDisabled(item[0].id)"
              :condition="cardCondition"
              :onClick="onChannelClick"
              :cardParameter="cardParameter"
            />
          </v-flex>
          <v-flex md12>
            <v-divider></v-divider>
          </v-flex>
        </v-layout>
      </Card>
      <v-divider></v-divider>
      <div class="button-align">
        <v-btn  color="#2196F3" @click="showGraph()">
          <img src="@/assets/graph.svg" width="14px" height="14px" />
          <span class="ml-2">
            {{
              $t("View graph")
            }}
          </span>
        </v-btn>
        <v-btn color="#FF5252" @click="clearAll()">
          <img src="@/assets/broom.svg" width="14px" height="14px" />
          <span class="ml-2">
            {{
              $t("Reset")
            }}
          </span>
        </v-btn>
      </div>
    </Card>
    <v-divider></v-divider>
    <GlobalGraph
      class="graph"
      v-if="graphActive"
      :series="series"
      :xAxisData="xAxis"
      :yAxis="yAxis"
      :theme="theme"
      :loading="loading"
    />
  </div>
</template>

<script>
const momentTz = require("moment-timezone");
import moment from "moment";
import _ from "lodash";
import { mixin, mapGettersMixin, miscellaneous } from "@/util/mixin/index";
import { mapGetters, mapMutations } from "vuex";
import CommonService from "@/services/Common";
import ScbService from "@/services/Scbs";
import GlobalGraph from "@/components/common/GlobalGraph";
import MapLegend from "@/components/common/MapLegend";
import CardCheckBoxSCB from "@/components/common/CardCheckBoxSCB";
import CardText from "@/components/AdvancedScb/CardText";

const selectionObj = () => {
  return {
    activeChannels: {},
    channelCheckbox: {},
    scbCheckbox: {},
    scbData: {},
    scbCardSelection: {},
    selectedParameters: {},
    clearAllChecked: false,
    scbLiveAvg: "live",
    parameterType: "current",
    graphActive: false,
    loading: false,
    enableWatch: false,
    loading: false,
    series: [],
    xAxis: [],
    disableChannelSelection: false,
    blockList: [],
    invList: [],
    activeFilter: {},
    isStringRatedPowerPresent: false,
    legend: [
      {
        name: "Known Issue",
        attr: {
          name: "square",
          color: "#ECB208",
        },
      },
      {
        name: "String deviation",
        attr: {
          name: "square",
          color: "#FF5252",
        },
      },
      {
        name: "NC",
        attr: {
          name: "square",
          color: "#455A64",
        },
      },
      {
        name: "Selected",
        attr: {
          name: "box",
          color: "#04112F",
        },
      },
    ],
  }
}

export default {
  mixins: [mixin, mapGettersMixin, miscellaneous],
  components: {
    MapLegend,
    CardText,
    GlobalGraph,
    CardCheckBox: CardCheckBoxSCB
  },
  props: {
    changesFromFilter: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      ...selectionObj()
    };
  },
  computed: {
    ...mapGetters(["getSelectedPlantId", "getActivePlantTimezone"]),
    cardParameter() {
      const tabParameterMap = {
        current: [
          {
            name: "Current (A)",
            value: "current",
          },
        ],
        string_dc_power: [
          {
            name: "Power (kW)",
            value: "string_dc_power",
          },
          {
            name: "Rated Power (kW)",
            value: "string_rated_power",
          },
          {
            name: "DC Load (%)",
            value: "string_dc_load",
          },
        ],
        string_dc_energy_today: [
          {
            name: "Energy (kWh)",
            value: "string_dc_energy_today",
          },
        ],
      };
      return tabParameterMap[this.parameterType];
    },
    filter() {
      return [
        {
          id: "Date",
          type: "singleDatePicker",
          title: "Date",
        },
        {
          dependentId: "inverterList",
          id: "blockList",
          type: "select",
          title: "Select Block",
          value: this.blockList,
        },
        {
          ref: "blockList",
          id: "inverterList",
          type: "selectCombo",
          title: "Select Inverters",
          value: this.invList,
          condition: (ref) => {
            return !!(ref && ref.text);
          },
        },
      ];
    },
    sortedData() {
      // sorting using device ID using lodash
      const keysList = Object.keys(this.scbData);
      if (!_.isEmpty(this.scbData)) {
        keysList.sort((a, b) => {
          const aArr = a.split("-");
          const bArr = b.split("-");
          const baseA = aArr.slice(0, 3);
          const baseB = bArr.slice(0, 3);
          if (_.isEqual(baseA, baseB)) {
            if (+aArr[aArr.length - 1] < +bArr[bArr.length - 1]) return -1;
            if (+aArr[aArr.length - 1] > +bArr[bArr.length - 1]) return 1;
          } else {
            if (+baseA[baseA.length - 1] < +baseB[baseB.length - 1]) return -1;
            if (+baseA[baseA.length - 1] > +baseB[baseB.length - 1]) return 1;
          }
          return 0;
        });
        return keysList.map((el) => this.scbData[el]);
      } else {
        return {};
      }
    },
    selectedBlockId() {
      return this.activeFilter.blockList;
    },
    selectedInverters() {
      return this.activeFilter.inverterList
        ? this.activeFilter.inverterList
        : [];
    },
    selectedInverterListName() {
      if (this.selectedInverters.length > 0) {
        return this.selectedInverters.map((el) => {
          return el.text;
        });
      } else {
        return [];
      }
    },
    full_date() {
      return this.activeFilter.Date
        ? this.activeFilter.Date.from
        : momentTz().tz(this.getActivePlantTimezone).format("YYYY-MM-DD");
    },
    isUpdateData() {
      return `${this.selectedInverters.map((el) => el.modifiedId).join()}||${
        this.full_date
      }`;
    },
    show_date() {
      return moment(this.full_date).format("YYYY/M/D");
    },
    isItToday() {
      return this.activeFilter.Date
        ? momentTz()
            .tz(this.getActivePlantTimezone)
            .isSame(this.full_date, "day")
        : true;
    },
    cardData() {
      let leftCardData = [
        {
          name: `${this.$t("Total Current")} (A)`,
          value: "total_string_current",
          optional: false,
          method: (item) => (item != null ? parseFloat(item).toFixed(2) : 'No Data'),
        },
        {
          name: `${this.$t("Voltage")} (V)`,
          value: "voltage",
          optional: false,
          method: (item) => (item != null ? parseFloat(item).toFixed(2) : 'No Data'),
        },
        {
          name: `${this.$t("Temp")} (°C)`,
          value: "temperature",
          optional: false,
          method: (item) => (item != null ? parseFloat(item).toFixed(2) : 'No Data'),
        },
        {
          name: `${this.$t("DC Power")} (kW)`,
          value: "dc_power",
          optional: false,
          method: (item) => (item != null ? parseFloat(item).toFixed(2) : 'No Data'),
        },
        {
          name: this.$t("Breaker Status"),
          value: "status1",
          optional: true,
          method: (item) => (item != null ? (item == 1 ? this.$t("ON") : this.$t("OFF")) : 'No Data'),
        },
        {
          name: this.$t("SPD Status"),
          value: "status2",
          optional: true,
          method: (item) => (item != null ? (item== 1 ? this.$t("Intact") : this.$t("Blown")) : 'No Data'),
        },
        {
          name: this.$t("DC Energy (kWh)"),
          value: "dc_energy_today",
          optional: false,
          method: (item) => (item != null ? parseFloat(item).toFixed(2) : 'No Data'),
        },
      ];

      if (this.isStringRatedPowerPresent) {
        leftCardData.push({
          name: this.$t("DC Load (%)"),
          value: "dc_load",
          optional: false,
          method: (item) => (item != null ? parseFloat(item).toFixed(2) : 'No Data'),
        });
      }

      return leftCardData;
    },
    buttonColor() {
      return this.theme == "dark" ? "info" : "grey";
    },
    yAxis() {
      // Check for selected parameters
      const hasSelectedParams = Object.values(this.selectedParameters).some(
        params => params.length > 0
      );
      
      let yAxis = [{
        type: "value",
        position: "left",
        axisLabel: { formatter: "{value}" },
        name: this.cardParameter[0].name,
      }];
      // For selected parameters case
      if (hasSelectedParams) {
        // Cache groupedCardData to prevent repeated operations
        const groupedCardData = _.groupBy(this.cardData, "value");
        
        // Extract all selected parameters at once
        const overallParameters = _.uniq(_.flatMap(Object.values(this.selectedParameters)));
        
        // Filter non-status parameters and map to names in one operation
        const leftAxisParams = overallParameters
          .filter(param => param !== "status1" && param !== "status2")
          .map(param => _.get(groupedCardData, `${param}[0].name`, param));
        
        yAxis = [{
          type: "value",
          position: "left",
          axisLabel: { formatter: "{value}" },
          name: leftAxisParams.join(" / "),
        }];
        
        // Simple check for status parameters
        const hasStatusSeries = this.series.some(obj => obj.name.includes("Breaker Status") || obj.name.includes("SPD Status"));
        const hasStatusParams = overallParameters.some(param => param === "status1" || param === "status2");
        
        if (hasStatusSeries && hasStatusParams) {
          yAxis.push({
            type: "value",
            position: "right",
            axisLabel: { formatter: "{value}" },
            name: "Breaker Status / SPD Status",
            min: 0,
            max: 2,
          });
        }
      }

      return yAxis;
    },
    isDateToday() {
      return momentTz().isSame(this.full_date, 'days')
    }
  },
  async created() {
    await this.initialConfigList();
    await this.setIntervalWithoutDelay(this.callAllApi);
  },
  methods: {
    ...mapMutations([
      "SET_LAST_CALL_TIME",
      "SET_SHOW_SNACKBAR",
      "SET_SNACKBAR_CONTENT",
      "SET_PROGRESS_BAR",
    ]),
    cardCondition(ch, isActive) {
      const currentTime = momentTz()
        .tz(this.getActivePlantTimezone)
        .format("HH");
      let active = !!isActive;
      const isRedBlink =
        parseFloat(ch.value) === 0.0 &&
        this.scbLiveAvg === "live" &&
        (ch.status === "no_issue" || ch.status === "ETSD1001");
      const isWithinGenerationTime = currentTime > 8 && currentTime < 18;

      if (isRedBlink && isWithinGenerationTime && active) {
        return "ch-value_selected";
      }

      if (
        isRedBlink &&
        isWithinGenerationTime &&
        !active &&
        ch.status !== "known_issue"
      ) {
        return "ch-value";
      }

      if (isRedBlink && isWithinGenerationTime && !active) {
        return "default";
      }

      if (!(isRedBlink && isWithinGenerationTime) && active) {
        return "default-select";
      }

      if (!(isRedBlink && isWithinGenerationTime) && !active) {
        return "default";
      }
    },
    onChannelClick(ch, state, id) {
      const identifier = `${id}-${ch.id}`;
      if (ch.status !== "not_connected") {
        this.$set(this.activeChannels, identifier, state);
      } else {
        let payload = {
          icon: "error",
          header: "Important !",
          message: "Not-Connected channel cannot be selected",
        };
        this.SET_SNACKBAR_CONTENT(payload);
        this.SET_SHOW_SNACKBAR(true);
      }
    },
    async callAllApi() {
      this.enableWatch = false;
      let updateTime = moment().format("MM-DD-YYYY H:mm:ss");
      this.SET_LAST_CALL_TIME(updateTime);
      await this.getScbTableData(this.selectedBlockId, this.selectedInverters);
      if (this.graphActive) {
        await this.showGraph();
      }
    },
    async fetchBlockList() {
      return new Promise(async (resolve, reject) => {
        const response = await CommonService.getDeviceBlockList(
          this.getSelectedPlantId,
          "scb"
        );
        if (response.status === 200) {
          resolve(response);
        } else {
          reject(new Error(response));
        }
      });
    },
    async initialConfigList() {
      const isStringRatedPowerPresent =
        await ScbService.isStringRatedPowerConfigured(this.getSelectedPlantId);
      this.isStringRatedPowerPresent = isStringRatedPowerPresent.data.message;
      const response = await this.fetchBlockList();
      this.blockList = response.data.message;
      await this.getInverterList(this.blockList[0].id);

      const Obj = {};
      const cloneFilterOption = _.cloneDeep(this.filter);
      cloneFilterOption.forEach((child) => {
        if (
          (child.condition &&
            (!!child.considerStateAlways || child.condition(Obj[child.ref]))) ||
          !child.condition
        ) {
          if (child.type === "select") {
            if (typeof child.value === "function") {
              Obj[child.id] = child.value(Obj[child.ref]);
            } else {
              Obj[child.id] = child.value[0];
            }
          } else if (child.type === "singleDatePicker") {
            let parameters = ["from", "to"];
            parameters.forEach((key) => {
              if (!Obj[child.id]) {
                Obj[child.id] = {};
              }
              Obj[child.id][key] = momentTz()
                .tz(this.getActivePlantTimezone)
                .format("YYYY-MM-DD");
            });
          } else if (child.type === "selectCombo") {
            Obj[child.id] = [child.value[0]];
          } else {
            Obj[child.id] = child.value;
          }
        }
      });
      this.activeFilter = Obj;
      this.$emit("filter:config", cloneFilterOption);
      this.$emit("initial:active_filter", Obj);
    },
    async fetchIdList(payload) {
      return new Promise(async (resolve, reject) => {
        const response = await CommonService.getIdList(...payload);
        if (response.status === 200) {
          resolve(response);
        } else {
          reject(new Error(response));
        }
      });
    },
    async getScbTableData(selectedBlockId, selectedInverters) {
      let modifiedId = [];
      selectedInverters.forEach((el) => {
        modifiedId.push(el.modifiedId);
      });

      try {
        this.SET_PROGRESS_BAR(true);
        const param = {
          plantId: this.getSelectedPlantId,
          index: this.isItToday ? this.scbLiveAvg : 'avg',
          blockId: selectedBlockId["id"],
          modifiedId: modifiedId,
          date: this.full_date,
          parameter1: [
            "voltage",
            "temperature",
            "total_string_current",
            "status1",
            "status2",
            "dc_power",
            "dc_energy_today"
          ],
          parameter2: this.parameterType == 'string_dc_power' ? this.cardParameter.map(p => p.value).filter(p => p !== "string_rated_power") : this.cardParameter.map(p => p.value),
        };

        if (this.isStringRatedPowerPresent) param.parameter1.push('dc_load')
        const response = await ScbService.fetchScbTableData(param);
        this.scbData = response.data;
        this.enableWatch = true;
        this.SET_PROGRESS_BAR(false);
        Object.entries(this.scbData).forEach(([key, value]) => {
          if (!this.scbCheckbox.hasOwnProperty(key)) {
            this.scbCheckbox[key] = false;
            if (!this.channelCheckbox.hasOwnProperty(key)) {
              this.$set(this.channelCheckbox, key, false);
            }
            let channels = value[0].channel;
            channels.forEach((el) => {
              if (el.status !== "not_connected") {
                this.activeChannels[`${key}-${el.id}`] = false;
              }
            });
          }
        });
      } catch (err) {
        this.SET_PROGRESS_BAR(false);
      }
    },
    async getChannelData(modifiedId) {
      try {
        this.SET_PROGRESS_BAR(true);
        const isScb = Object.keys(this.scbCheckbox).filter(
          (el) => !!this.scbCheckbox[el]
        );
        const selectedDate = moment(this.activeFilter["Date"].from).format(
          "YYYY-MM-DD"
        );
        const param = {
          plantId: this.getSelectedPlantId,
          modifiedId: modifiedId,
          date: selectedDate,
          isScb: isScb,
          parameters: this.parameterType == 'string_dc_power' ? this.cardParameter.map(p => p.value).filter(p => p !== "string_rated_power") : this.cardParameter.map(p => p.value)
        };
        const response = await ScbService.fetchScbGraphData(param);

        this.series.length = 0;
        this.SET_PROGRESS_BAR(false);
        const paramterNameMap = _.groupBy(this.cardParameter, 'value')

        Object.keys(response.data.finalData).forEach((id) => {
          const splitIdArr = id.split("-");
          const paramName = _.last(splitIdArr);
          
          this.series.push({
            name: `${splitIdArr.slice(0, -1).join("-")}-${
              paramterNameMap[paramName][0].name
            }`,
            type: "line",
            data: response.data.finalData[id],
            yAxisIndex: !splitIdArr.includes('dc_load') ? 0 : 1
          });
        });
        this.xAxis = response.data.axis;
      } catch (err) {
        this.SET_PROGRESS_BAR(false);
      }
    },
    async getInverterList(selectedBlockId) {
      const res = await CommonService.getIdList(
        this.getSelectedPlantId,
        "SCB",
        2,
        selectedBlockId
      );
      let roomList = res.data.message;
      let roomId = [];
      roomList.forEach((el) => {
        roomId.push(el.modifiedId);
      });
      const invListRes = await this.fetchIdList([
        this.getSelectedPlantId,
        "SCB",
        3,
        roomId.join(","),
      ]);
      this.invList = invListRes.data.message;
    },
    selectScbHandler(scbId) {
      const elementClassName = this.simpleString(scbId);
      const ele = document.querySelector(`.--${elementClassName}`);
      
      if (!ele) return;
      
      const cards = ele.querySelectorAll(".card-uniform");
      const isSelected = this.scbCheckbox[scbId];
      
      ele.classList.toggle("scb-selected", isSelected);
      
      if (isSelected) {
        this.handleScbSelection(scbId, cards);
        this.clearChannelSelections();
      } else {
        this.handleScbDeselection(scbId, cards);
      }
      
      this.disableChannelSelection = Object.values(this.scbCheckbox).some(Boolean);
      
      this.updateAssociatedChannels(scbId);
    },

    handleScbSelection(scbId, cards) {
      cards.forEach((card, index) => {
        card.classList.add("scbCard");
        const parameter = this.cardData[index].value;
        const key = `${scbId}-${parameter}`;
        
        this.$set(this.scbCardSelection, key, true);
        
        if (!this.selectedParameters[scbId]) {
          this.$set(this.selectedParameters, scbId, []);
        }
        
        if (!this.selectedParameters[scbId].includes(parameter)) {
          this.selectedParameters[scbId].push(parameter);
        }
      });
    },
    handleScbDeselection(scbId, cards) {
      cards.forEach((card, index) => {
        card.classList.remove("scbCard");
        const parameter = this.cardData[index].value;
        const key = `${scbId}-${parameter}`;
        
        this.$set(this.scbCardSelection, key, false);
        
        if (this.selectedParameters[scbId]) {
          const paramIndex = this.selectedParameters[scbId].indexOf(parameter);
          if (paramIndex > -1) {
            this.selectedParameters[scbId].splice(paramIndex, 1);
          }
        }
      });
      
      if (this.selectedParameters[scbId] && this.selectedParameters[scbId].length === 0) {
        this.$delete(this.selectedParameters, scbId);
      }
    },
    clearChannelSelections() {
      const channelKeys = Object.keys(this.channelCheckbox);
      const activeKeys = Object.keys(this.activeChannels);
      
      channelKeys.forEach(key => {
        this.$set(this.channelCheckbox, key, false);
      });
      
      activeKeys.forEach(key => {
        this.$set(this.activeChannels, key, false);
      });
    },
    updateAssociatedChannels(scbId) {
      const isSelected = this.scbCheckbox[scbId];
      
      Object.keys(this.activeChannels).forEach(channelKey => {
        const id = channelKey.slice(0, channelKey.indexOf('-') > 0 ? channelKey.indexOf('-') : 8);
        
        if (id === scbId) {
          this.$set(this.activeChannels, channelKey, isSelected);
        }
      });
    },
    isChannelSelectDisabled() {
      const isScbSelected = Object.values(this.scbCheckbox).some(
        (value) => value
      );
      const hasSelectedParameters = Object.keys(this.scbCardSelection).some(
        (key) => this.scbCardSelection[key]
      );
      return isScbSelected || hasSelectedParameters;
    },
    selectChannelHandler(val) {
      if (!this.disableChannelSelection) {
        val.channel.forEach((el) => {
          if (el.status !== "not_connected") {
            let id = `${val.id}-${el.id}`;
            this.$set(this.activeChannels, id, this.channelCheckbox[val.id]);
          }
        });
      } else {
        this.$set(this.channelCheckbox, val.id, false);
      }
    },
    selectScbParameter(scbId, parameter) {
      const key = `${scbId}-${parameter}`;
      
      const newSelectionState = !this.scbCardSelection[key];
      this.$set(this.scbCardSelection, key, newSelectionState);

      if (newSelectionState) {
        this.addParameterToSelection(scbId, parameter);
      } else {
        this.removeParameterFromSelection(scbId, parameter);
      }
      
      this.updateSelectionStates(scbId);
    },
    addParameterToSelection(scbId, parameter) {
      if (!this.selectedParameters[scbId]) {
        this.$set(this.selectedParameters, scbId, []);
      }
      
      if (!this.selectedParameters[scbId].includes(parameter)) {
        this.selectedParameters[scbId].push(parameter);
      }
    },
    removeParameterFromSelection(scbId, parameter) {
      if (!this.selectedParameters[scbId]) return;
      
      this.selectedParameters[scbId] = this.selectedParameters[scbId].filter(p => p !== parameter);
      
      if (this.selectedParameters[scbId].length === 0) {
        this.$delete(this.selectedParameters, scbId);
      }
    },

    updateSelectionStates(scbId) {
      this.disableChannelSelection = Object.values(this.scbCardSelection).some(Boolean);
      
      this.$set(this.channelCheckbox, scbId, false);
      
      if (this.disableChannelSelection) {
        this.clearAllChannelSelections();
      } else {
        this.clearSpecificChannelSelections(scbId);
      }
    },
    clearAllChannelSelections() {
      Object.keys(this.activeChannels).forEach(key => {
        this.$set(this.activeChannels, key, false);
      });
      
      Object.keys(this.channelCheckbox).forEach(key => {
        this.$set(this.channelCheckbox, key, false);
      });
    },
    clearSpecificChannelSelections(scbId) {
      Object.keys(this.activeChannels).forEach(channelKey => {
        const id = channelKey.includes('-') 
          ? channelKey.substring(0, channelKey.indexOf('-')) 
          : channelKey.substring(0, 8);
        
        if (id === scbId) {
          this.$set(this.activeChannels, channelKey, false);
        }
      });
    },
    async showGraph() {
      try {
        const hasSelectedParams = Object.values(this.selectedParameters).some(params => params.length > 0);
        const selectedChannels = Object.keys(this.activeChannels).filter(key => this.activeChannels[key]);
        
        if (!hasSelectedParams && selectedChannels.length === 0) {
          return this.showErrorMessage("Please select at least one SMB or Channel in order to plot graph");
        }
        
        this.SET_PROGRESS_BAR(true);
        
        if (hasSelectedParams) {
          await this.handleParameterGraph();
        } else if (selectedChannels.length > 0) {
          await this.handleChannelGraph(selectedChannels);
        }
        
        this.graphActive = true;
        this.scrollToGraph();
      } catch (error) {
        console.error("Error showing graph:", error);
        this.showErrorMessage("Failed to load graph data. Please try again.");
      } finally {
        this.SET_PROGRESS_BAR(false);
      }
    },
    async handleParameterGraph() {
      const selectedDate = moment(this.activeFilter["Date"].from).format("YYYY-MM-DD");
      
      const param = {
        plantId: this.getSelectedPlantId,
        modifiedId: _.mapValues(this.selectedParameters, () => []),
        date: selectedDate,
        isScb: _.keys(this.selectedParameters),
        parameters: this.selectedParameters,
      };
      
      const response = await ScbService.fetchScbGraphData(param);
      const groupedCardData = _.groupBy(this.cardData, "value");
      
      let statusExists = false;
      this.series = _.map(response.data.finalData, (data, id) => {
        const idParts = id.split("-");
        const paramName = _.last(idParts);
        const prefix = idParts.slice(0, -1).join("-");
        
        const paramDisplayName = _.get(groupedCardData, `${paramName}[0].name`, paramName);
        if ((paramName === "status1" || paramName === "status2")) {
          statusExists = true;
        }
        return {
          name: `${prefix}-${paramDisplayName}`,
          type: "line",
          data: data,
          yAxisIndex: (paramName === "status1" || paramName === "status2") ? 1 : 0,
        };
      });
      
      this.xAxis = response.data.axis;
    },
    async handleChannelGraph(selectedChannels) {
      const modifiedId = {};
      
      for (const channelKey of selectedChannels) {
        const id = channelKey.slice(0, 7 + (channelKey[7] !== "-"));
        const chId = channelKey.slice(-2).replace("-", "");
        
        if (!modifiedId[id]) {
          modifiedId[id] = [chId];
        } else {
          modifiedId[id].push(chId);
        }
      }
      
      await this.getChannelData(modifiedId);
    },
    showErrorMessage(message) {
      const payload = {
        icon: "error", 
        header: "An error has occurred",
        message: message
      };
      this.SET_SNACKBAR_CONTENT(payload);
      this.SET_SHOW_SNACKBAR(true);
    },
    scrollToGraph() {
      this.$nextTick(() => {
        const graphElement = document.querySelector(".graph");
        
        if (!graphElement) return;
        
        try {
          graphElement.scrollIntoView({ 
            behavior: 'smooth', 
            block: 'start'
          });
        } catch (e) {
          try {
            graphElement.scrollIntoView();
          } catch (e2) {
            const rect = graphElement.getBoundingClientRect();
            const offset = rect.top + window.scrollY;
            window.scrollTo({
              top: offset,
              behavior: 'smooth'
            });
          }
        }
      });
    },
    clearAll() {
      Object.keys(this.activeChannels).forEach((el) => {
        this.activeChannels[el] = false;
      });
      this.channelCheckbox = {};
      this.scbCheckbox = {};
      this.scbCardSelection = {};
      this.selectedParameters = {};

      // Removing the border from scb checkbox container if its there
      this.disableChannelSelection = false;
      let eleArr = document.querySelectorAll(`.scbBox`);
      eleArr.forEach((el) => {
        if (el.classList.contains("scb-selected")) {
          el.classList.remove("scb-selected");
        }
        const cards = el.querySelectorAll(".card-uniform");
        cards.forEach((card) => {
          card.classList.remove("scbCard");
        });
      });
      this.clearAllChecked = !this.clearAllChecked;
      this.graphActive = false;
    },
    toggleLiveAvgHandler(val) {
      this.scbLiveAvg = val;
      this.setIntervalWithoutDelay(this.callAllApi);
    },
    selectParameterType(val) {
      this.scbLiveAvg = 'live';
      this.parameterType = val;
      this.clearAll();

      this.setIntervalWithoutDelay(this.callAllApi);
    },
  },
  watch: {
    changesFromFilter: {
      handler(val) {
        this.activeFilter = val;
      },
      deep: true,
    },
    async getSelectedPlantId() {
      const {
        activeChannels,
        channelCheckbox,
        scbCheckbox,
        scbData,
        scbCardSelection,
        selectedParameters,
        clearAllChecked,
        graphActive,
        scbLiveAvg,
        parameterType,
        series,
        xAxis,
        disableChannelSelection,
        blockList,
        invList,
        isStringRatedPowerPresent
      } = selectionObj()
      this.activeChannels = activeChannels;
      this.channelCheckbox = channelCheckbox;
      this.scbCheckbox = scbCheckbox;
      this.scbData = scbData;
      this.scbCardSelection = scbCardSelection;
      this.selectedParameters = selectedParameters;
      this.clearAllChecked = clearAllChecked;
      this.graphActive = graphActive;
      this.scbLiveAvg = scbLiveAvg;
      this.parameterType = parameterType;
      this.series = series;
      this.xAxis = xAxis;
      this.disableChannelSelection = disableChannelSelection;
      this.blockList = blockList;
      this.invList = invList;
      this.isStringRatedPowerPresent = isStringRatedPowerPresent;
      await this.initialConfigList();
      await this.setIntervalWithoutDelay(this.callAllApi);
    },
    isReload() {
      if (this.isReload) {
        this.setIntervalWithoutDelay(this.callAllApi);
      }
    },
    async "selectedBlockId.id"(val) {
      if (this.enableWatch) {
        await this.getInverterList(val);

        this.$set(this.activeFilter, "inverterList", [this.invList[0]]);

        this.$emit("filter:config", _.cloneDeep(this.filter));
        this.$emit("initial:active_filter", this.activeFilter);
      }
    },
    isUpdateData() {
      if (this.enableWatch) {
        if (this.selectedInverters.length === 0) {
          let payload = {
            icon: "error",
            message: "Minimun one device will be selected",
          };
          this.SET_SNACKBAR_CONTENT(payload);
          this.SET_SHOW_SNACKBAR(true);
        } else {
          const currentDate = momentTz()
            .tz(this.getActivePlantTimezone)
            .format("YYYY-MM-DD");
          let date = moment(this.full_date).format("YYYY-MM-DD");

          if (moment(date).isBefore(currentDate)) {
            this.scbLiveAvg = "avg";
          } else {
            this.scbLiveAvg = "live";
          }
          this.setIntervalWithoutDelay(this.callAllApi);
        }
      }
    },
  },
};
</script>

<style scoped>
.scb-selected {
  box-shadow: inset 0 0 0 2px #818fff;
}

.graph {
  width: 100%;
  height: 400px;
}

.scb_data {
  /* color: white; */
  font-size: 16px;
}

.theme--light .scb_data {
  /* color: black; */
  font-size: 16px;
}

#card-box {
  /* background-color: #1b243a; */
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.theme--light #card-box {
  /* background-color: #E0E0E0; */
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.button-align {
  text-align: center;
  padding-top: 12px;
  padding-bottom: 12px;
}

.chisActive h4 {
  min-width: 128px;
  margin: 4px;
  border-radius: 4px;
  min-height: 35px;
  align-items: center;
  display: flex;
  justify-content: center;
  cursor: pointer;
}

.select {
  border: 1px solid;
  width: 245px;
}

.theme--light .scb_header {
  /* color: #3347df; */
  font-weight: bold;
  font-size: 14px;
}

.scb_header {
  /* color: #818fff; */
  font-weight: bold;
  font-size: 14px;
}

.checkbox {
  padding-left: 15px;
  display: inline-flex;
}

.theme--dark .tooltip {
  margin-top: 9.5px;
  margin-left: 3px;
  /* color: #909cff; */
  font-size: 12px;
  position: relative;
  display: inline-block;
  font-weight: bold;
}

.theme--light .tooltip {
  margin-top: 9.5px;
  margin-left: 3px;
  /* color: #3347df; */
  font-size: 12px;
  position: relative;
  display: inline-block;
  font-weight: bold;
}

.theme--dark .tooltip .tooltiptext {
  visibility: hidden;
  width: 255px;
  /* background-color: #F5F5F5; */
  /* color: black; */
  text-align: center;
  border-radius: 6px;
  padding: 2px 0;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
  bottom: 100%;
  left: 50%;
  margin-left: -60px;
}

.theme--light .tooltip .tooltiptext {
  visibility: hidden;
  width: 255px;
  /* background-color: #e3e3e3; */
  color: black;
  text-align: center;
  border-radius: 6px;
  padding: 2px 0;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
  bottom: 100%;
  left: 50%;
  margin-left: -60px;
}

.tooltip:hover .tooltiptext {
  visibility: visible;
}

.select_inv {
  /* color: #818fff !important; */
  width: 200px;
}

.card-separation {
  margin-bottom: 15px !important;
  /* /* border-radius: 8px; */
}

.v-message {
  min-height: 0px;
  min-width: 0px;
}

.container {
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 4px;
}

.container.grid-list-lg *:not(:only-child) .layout:first-child {
  margin-top: 0px;
}

.container.grid-list-lg .layout:not(:only-child) {
  margin: auto 0px;
}

.theme--light.v-label {
  color: black;
}

.scbCard {
  box-shadow: inset 0 0 0 2px #818fff;
}

.card-uniform {
  height: 40px;
  width: 48%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: start;
  background-color: var(--v-primary-darken1);
  cursor: pointer;
}

.scbCardParam {
  box-shadow: inset 0 0 0 2px #818fff;
}

@media only screen and (min-width: 1904px) and (max-width: 2544px) {
  .tablediv {
    max-height: 56.5vh;
    min-height: 56.5vh;
    overflow-y: auto;
    overflow-x: hidden;
    margin: 4px;
  }
}

@media only screen and (min-width: 1584px) and (max-width: 1904px) {
  .tablediv {
    max-height: 430px;
    min-height: 430px;
    overflow-y: auto;
    overflow-x: hidden;
    margin: 4px;
  }
}

@media only screen and (min-width: 1394px) and (max-width: 1585px) {
  .tablediv {
    max-height: 340px;
    min-height: 340px;
    overflow-y: auto;
    overflow-x: hidden;
    margin: 4px;
  }
}

@media only screen and (min-width: 1280px) and (max-width: 1394px) {
  .tablediv {
    max-height: 270px;
    min-height: 270px;
    overflow-y: auto;
    overflow-x: hidden;
    margin: 4px;
  }
}

.scb_checkbox {
  margin-left: 12px;
  margin-top: 0px;
  margin-bottom: 4px;
}
</style>
<style>
.button-align .v-btn {
  height: 32px;
  text-transform: none;
}

#select
  .v-text-field.v-text-field--enclosed
  > .v-input__control
  > .v-input__slot {
  min-height: 20px;
  width: 100%;
}

#select .v-input__control {
  display: contents;
}

#date .el-input__inner {
  border: 1px solid !important;
  /* background-color: #1B243A */
}

.theme--light #date .el-input__inner {
  border: 1px solid !important;
  /* background-color: #E0E0E0 !important; */
}

.container.grid-list-lg .layout .flex {
  padding: 4px;
}

.v-messages {
  min-height: 0px;
}

.v-select__selection--comma {
  margin: 0;
}

.v-text-field.v-text-field--enclosed {
  margin: 2px;
}
</style>
